import {
  Heading,
  Text,
  SubHeading,
  Standfirst,
  Image,
  Figure,
  BlockQuote,
  Note,
  List,
  OrderedList,
  ComponentPlaceholder,
} from "../components/Elements";

import Scroller from "../components/Scroller";
import ProgressScroller from "../components/ProgressScroller";
import fixRelativeLinks from "../helpers/fixRelativeLinks";

const makeItem = (Component, value) => {
  const object = { Component, props: {} };

  if (typeof value === "object") {
    object.props = value;
  }

  if (typeof value === "string") {
    object.props = { children: fixRelativeLinks(value) };
  }

  // Deal with arrays
  if (value instanceof Array) {
    object.props = {
      items: value,
    };
  }

  return object;
};

const useContent = (items, additionalComponents = {}) => {
  const baseElements = {
    heading: Heading,
    subHeading: SubHeading,
    text: Text,
    image: Image,
    figure: Figure,
    standfirst: Standfirst,
    blockQuote: BlockQuote,
    note: Note,
    list: List,
    orderedList: OrderedList,
    scroller: Scroller,
    progressScroller: ProgressScroller,
    ...additionalComponents,
  };

  if (!items) return [];

  return items.map(({ type, value }) => {
    if (!type) return null;

    if (baseElements[type]) {
      if (type === "scroller" || type === "progressScroller") {
        const viz = baseElements[value.viz];
        value.vizElement = viz;
      }

      return makeItem(baseElements[type], value);
    }

    // Placeholder if component is missing
    return makeItem(ComponentPlaceholder, value);
  });
};

export default useContent;
